var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTablet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.89 25C147.783 25.8308 149.855 26.4146 151.535 27.5597C155.118 30.0296 156.978 33.6333 156.978 38.023C157 79.326 157 120.629 156.978 161.921C156.978 169.128 151.154 174.978 143.975 174.978C114.655 175 85.3342 175 56.0027 174.978C48.835 174.978 43 169.117 43 161.921C43 120.629 43 79.326 43 38.0342C43.0112 32.2188 46.8638 27.1892 52.4636 25.5389C53.0124 25.3817 53.5612 25.1796 54.1099 25C84.707 25 115.304 25 145.89 25ZM148.231 100.163C148.231 79.8986 148.231 59.6456 148.231 39.3814C148.231 35.3847 146.64 33.7793 142.676 33.7793C114.229 33.7793 85.7822 33.7793 57.3466 33.7793C53.3596 33.7793 51.7692 35.3735 51.7692 39.3477C51.7692 79.7639 51.7692 120.191 51.7692 160.607C51.7692 164.604 53.3596 166.21 57.3242 166.21C85.771 166.21 114.218 166.21 142.653 166.21C146.629 166.21 148.242 164.604 148.242 160.641C148.242 140.478 148.242 120.315 148.242 100.152L148.231 100.163Z",
    fill: "#F4BF35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8798 157.329V148.752H113.042V157.329H86.8798Z",
    fill: "#EA8632"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 150,
    fill: "white",
    transform: "translate(43 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet);
export default __webpack_public_path__ + "static/media/Tablet.43d35a02e8d69d1a39c919097deb567b.svg";
export { ForwardRef as ReactComponent };